<div class="test-connection-container">
  <app-alert [show]="showMessage"
             [autohide]="autohideDelay"
             [type]="alertMessage?.type"
             [message]="alertMessage?.text"
             (closeAlert)="showMessage = false"
  ></app-alert>

  <form [formGroup]="connectionForm" class="connection-form">
    <app-dropdown
      [label]="'Pharmacy Management Systems'"
      [options]="integrationTypes"
      [isOptionObject]="true"
      [required]="true"
      [placeholder]="'Select'"
      formControlName="integrationType"
      [chosenOptionId]="connectionForm.controls['integrationType'].value"
      [tabInd]="0"
      #integrationTypeDropdown
    ></app-dropdown>

  </form>

  <div class="controls">
    <app-button customClasses="w-full"
                text="Continue"
                class="continue"
                [disabled]="connectionForm.invalid || (loading$ | async)"
                (clicked)="next.emit(PharmacyManagementSystemIntegrationStepsEnum.PendingConnection)"
                #continueButton
    >
    </app-button>

    <app-button subStyle="transparent"
                customClasses="w-full"
                text="Cancel"
                class="cancel"
                (clicked)="cancel.emit()"
    >
    </app-button>
  </div>
</div>
